// client/src/pages/user/MassOrder.js
import { useState } from "react";
import api from "../../api/axiosInstance";
import toast from "react-hot-toast";

export default function MassOrder() {
  const [file, setFile] = useState(null);

  const upload = async () => {
    if (!file) return toast.error("Select a CSV file");

    const form = new FormData();
    form.append("file", file);

    try {
      await api.post("/orders/mass/csv", form);
      toast.success("Mass order placed successfully");
      setFile(null);
    } catch (e) {
      toast.error(e.response?.data?.message || "Upload failed");
    }
  };

  return (
    <div className="max-w-3xl space-y-8">
      <h1 className="text-2xl font-bold">Mass Order</h1>

      {/* UPLOAD */}
      <div className="card-glass p-6 space-y-4 max-w-xl">
        <input
          type="file"
          accept=".csv"
          onChange={(e) => setFile(e.target.files[0])}
        />

        <button onClick={upload} className="btn-primary w-full">
          Upload CSV
        </button>
      </div>

      {/* INSTRUCTIONS */}
      <div className="card-glass p-6 space-y-4 text-sm text-gray-300">
        <h2 className="font-semibold text-white">
          Mass Order Instructions
        </h2>

        <ol className="list-decimal pl-5 space-y-2">
          <li>Create a CSV file with the following columns:</li>
          <li>
            <code className="bg-black/40 px-2 py-1 rounded">
              service_id, link, quantity
            </code>
          </li>
          <li>Each row represents one order.</li>
          <li>Quantity must be within service min & max limits.</li>
          <li>Save the file in <b>.csv</b> format.</li>
          <li>Upload the file using the form above.</li>
        </ol>

        <p className="text-yellow-400 text-xs">
          ⚠ Invalid rows will be skipped automatically.
        </p>
      </div>
    </div>
  );
}
